module.exports = __webpack_public_path__ + "Server-CalamariNeedsUpgrade.TentaclePassive.0ac101d4c1f56c08b91e018d061b0c46.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-CalamariNeedsUpgrade.TentaclePassive.png
// module id = 1234
// module chunks = 1